import React, { useState, useEffect } from "react";
import "../../assets/css/candidate-tab-form.css";
import "../../assets/css/inner-tabs.css";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import Loader from "../Common/loader";
import { useNavigate } from "react-router-dom";
import ADDRadio from "./addRadio";
import ADDText from "./addText";
import ADDCheckbox from "./addCheckbox";
import ADDDate from "./addDate";
import ADDSelect from "./addSelect";
import {
  saveBusinessAddress,
  deleteBusinessAddress,
  businessAddressValidation,
  deleteValidateAddress,
} from "../../Actions/businessAddressActions";
import { getPincode } from "../../Actions/pincodeAction";
import DownloadIcon from "../../assets/img/download-icon-black.svg";
import ADDAutoCompleteSelect from "./addAutoCompleteSelect";
import { validatePincode } from "../../Helper/common";
import { dateFormat } from "../../Helper/common";
import ConfirmationPopup from "./confirmationPopup";

const MainForm = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    businessAddress,
    active,
    industries,
    reference,
    reRenderAgain,
    redirectToTabOne = true,
  } = props;
  const [loading, setLoading] = useState(false);
  const [businessAddressDetails, setBusinessAddress] = useState({});
  const [errorData, setErrorData] = useState([]);
  const [unsavedErrorData, setUnsavedErrorData] = useState([]);
  const [currentField, setCurrentField] = useState(null);
  const [activeTab, setActiveTab] = useState(1);
  const [isIndia, setIsIndia] = useState([]);
  const [tillDateChecked, setTillDateChecked] = useState({});
  const storeData = useSelector((state) => state.businessSaveData);
  const { businessSaveData, loading: businessSaveDataLoading } = storeData;
  const [maxDOJ, setMaxDOJ] = useState({});
  const [minDOL, setMinDOL] = useState({});
  const storeDataValid = useSelector((state) => state.businessValidationData);
  const { businessValidationData } = storeDataValid;
  const [isValidated, setIsValidated] = useState(0);
  const [showValidationPopup, setShowValidationPopup] = useState(false);
  const [validationPopupMsg, setValidationPopupMsg] = useState("");
  const [validationPopupTitle, setValidationPopupTitle] = useState("");

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    setBusinessAddress(businessAddress);
    if (businessAddress && businessAddress.checksDetails) {
      if (redirectToTabOne == true) {
        navigate(`/case-initiation/check-detail/${reference}/18`);
        setActiveTab(1);
      }
      setIsValidated(0);
      setShowValidationPopup(false);
      dispatch(deleteValidateAddress());
    }
  }, [businessAddress]);

  useEffect(() => {
    if (
      typeof businessSaveData.data !== "undefined" &&
      businessSaveData.data !== null
    ) {
      const group = businessSaveData.data.group
        ? businessSaveData.data.group.group_id
        : "";
      const hasNextCheck = businessSaveData.data.nextCheck != "" ? true : false;
      const reference = businessSaveData.data.reference_number;
      if (!hasNextCheck) {
        if (group == "profile_preview") {
          navigate(`/case-initiation/profile-preview/${reference}`);
          dispatch(deleteBusinessAddress());
        } else if (typeof group != "undefined" && group != "") {
          navigate(`/case-initiation/check-detail/${reference}/${group}`);
          dispatch(deleteBusinessAddress());
        }
      } else {
        changeActiveTab(
          parseInt(businessSaveData.activeTab + 1),
          businessSaveData.data.nextCheck
        );
        dispatch(deleteBusinessAddress());
        reRenderAgain(false);
        window.scrollTo(0, 0);
      }
    }
  }, [businessSaveData]);

  const changeActiveTab = (index, nextCheck) => {
    if (
      typeof businessAddressDetails.checksDetails !== "undefined" &&
      businessAddressDetails.checksDetails !== null
    ) {
      if (index) {
        navigate(`/case-initiation/check-detail/${reference}/18/${nextCheck}`);
      }
    }
    setActiveTab(index);
  };

  useEffect(() => {
    setLoading(props.isLoading);
  }, [props.isLoading]);

  const handleRadioChange = (radioValues) => {
    const { dataset, value } = radioValues;
    setCurrentField(dataset.fieldname);
    if (dataset.fieldname === "address_belongs_to") {
      const india = value === "Within India" ? true : false;
      let updatedIndia = _.cloneDeep(isIndia);
      updatedIndia[parseInt(dataset.checkdetailsindex)] = india;
      setIsIndia(updatedIndia);
    }
    updateAddressDetails(dataset, value);
  };

  const handleSelectChange = (selectValues) => {
    const { dataset, value } = selectValues;
    setCurrentField(dataset.fieldname);
    updateAddressDetails(dataset, value);
  };

  const handleTextChange = (textValues) => {
    const { dataset, value } = textValues;
    setCurrentField(dataset.fieldname);
    let fieldName = textValues.dataset.fieldname;
    const updatedErrorData = _.cloneDeep(errorData);
    if (
      fieldName === "pin_code" &&
      isIndia[parseInt(textValues.dataset["checkdetailsindex"])] === true
    ) {
      let pinArr = [];
      pinArr[0] = textValues;
      let valid = validatePincode(pinArr[0].value);
      if (valid) {
        dispatch(getPincode(pinArr));
      }
      updatedErrorData[parseInt(dataset.checkdetailsindex)]["pin_code"] =
        !valid;
      setErrorData(updatedErrorData);
    }
    updateAddressDetails(dataset, value);
  };

  const storePincodeData = useSelector((state) => state.pincode);
  const { pincodeData } = storePincodeData;
  useEffect(() => {
    if (
      typeof businessAddressDetails.checksDetails !== "undefined" &&
      businessAddressDetails.checksDetails !== null
    ) {
      if (
        typeof pincodeData.data !== "undefined" &&
        pincodeData.data !== null
      ) {
        let addDetails = _.cloneDeep(businessAddressDetails);
        addDetails.checksDetails[activeTab - 1].fields["city"].field_value =
          pincodeData.data.city_name;
        addDetails.checksDetails[activeTab - 1].fields["location"].field_value =
          pincodeData.data.state_name;
        setBusinessAddress(addDetails);
        const updatedErrorData = [...errorData];
        updatedErrorData[activeTab - 1]["city"] = false;
        updatedErrorData[activeTab - 1]["location"] = false;
        setErrorData(updatedErrorData);
      }
    }
  }, [pincodeData, storePincodeData]);

  const handleCheckboxChange = (checkboxValues) => {
    const { dataset, value } = checkboxValues;
    setCurrentField(dataset.fieldname);
    if (dataset.fieldname === "till_date") {
      let savedDate = dateFormat("DD-MM-YYYY", new Date());
      let updatedTillDateChecked = _.cloneDeep(tillDateChecked);
      const updatedValue =
        updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] === true
          ? ""
          : "1";
      if (updatedValue == "") {
        const updatedErrorData = [...errorData];
        updatedErrorData[parseInt(dataset.checkdetailsindex)][
          "residing_from"
        ] = false;
        setErrorData(updatedErrorData);
      }
      updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] =
        !updatedTillDateChecked[parseInt(dataset.checkdetailsindex)];
      setTillDateChecked(updatedTillDateChecked);
      updateAddressDetails(dataset, updatedValue, savedDate);
    }
  };

  const handleSaveDate = (checkDetailsIndex, fieldName, savedDate) => {
    setCurrentField(fieldName);
    const unsavedData = [...errorData];
    setUnsavedErrorData(unsavedData);
    let updatedAddDetails = _.cloneDeep(businessAddressDetails);
    for (var i in updatedAddDetails.checksDetails[parseInt(checkDetailsIndex)]
      .fields) {
      if (i == fieldName) {
        updatedAddDetails.checksDetails[parseInt(checkDetailsIndex)].fields[
          i
        ].field_value = savedDate;
      }
    }
    setBusinessAddress(updatedAddDetails);
  };

  const updateAddressDetails = (dataset, value, dolVal = "") => {
    console.log(errorData);
    const unsavedData = [...errorData];
    setUnsavedErrorData(unsavedData);
    let addDetails = _.cloneDeep(businessAddressDetails);
    addDetails.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
      dataset.fieldname
    ].field_value = value;
    // if (dataset.fieldname === "till_date") {
    //   addDetails.checksDetails[parseInt(dataset.checkdetailsindex)].fields[
    //     "residing_from"
    //   ].field_value = dolVal;
    // }
    setBusinessAddress(addDetails);
  };

  useEffect(() => {
    if (
      typeof businessAddressDetails.checksDetails !== "undefined" &&
      businessAddressDetails.checksDetails !== null
    ) {
      let errorArr = [];
      if (
        typeof businessAddressDetails.checksDetails !== "undefined" &&
        businessAddressDetails.checksDetails !== null
      ) {
        const checksDetails = businessAddressDetails.checksDetails;
        for (var i in checksDetails) {
          let obj = {};
          for (var j in checksDetails[i].fields) {
            if (
              j === "pin_code" &&checksDetails[i].fields["address_belongs_to"].field_value=='Within India'&&
              checksDetails[i].fields[j].field_value !== ""
            ) {
              let valid = validatePincode(
                checksDetails[i].fields[j].field_value
              );
              obj[j] = !valid;
            } else {
              // if (checksDetails[i].fields[j].field_value !== '') {
              //   obj[j] = false;
              // } else {
              obj[j] = false;
              //}
            }
          }
          errorArr.push(obj);
        }
      }
      if (unsavedErrorData.length === 0) {
        setErrorData(errorArr);
      } else {
        const index = activeTab - 1;
        //const newErr = _.cloneDeep(unsavedErrorData);
        const newErr = [...unsavedErrorData];
        if (currentField) {
          newErr[index][currentField] = false;
        }
        setErrorData(newErr);
      }
    }
  }, [businessAddressDetails, businessAddress]);

  useEffect(() => {
    if (
      typeof businessValidationData.data !== "undefined" &&
      businessValidationData.data !== null
    ) {
      if (businessValidationData.data.valid == 1) {
        setIsValidated(1);
        dispatch(deleteValidateAddress());
        setShowValidationPopup(false);
        let elementExists = document.getElementById("saveHandlerElement");
        if (typeof elementExists != "undefined" && elementExists != null) {
          //document.getElementById('saveHandlerElement').click();
          const checksLength = Object.keys(
            businessAddressDetails.checksDetails
          ).length;
          const case_check_id =
            businessAddressDetails.checksDetails[checksLength - 1][
              "case_check_id"
            ];
          saveHandler(null, case_check_id, checksLength);
        }
      } else {
        setIsValidated(0);
        //alert(businessValidationData.data.msg);
        setShowValidationPopup(true);
        setValidationPopupMsg(businessValidationData.data.msg);
        setValidationPopupTitle(businessValidationData.data.etype);
      }
    }
  }, [businessValidationData]);

  const closeValidationPopup = () => {
    setShowValidationPopup(false);
    dispatch(deleteValidateAddress());
  };

  const proceedValidation = () => {
    setShowValidationPopup(false);
    dispatch(deleteValidateAddress());
  };

  const saveHandler = async (e, caseCheckId, index) => {
    props.setIsLoading(true);
    e?.preventDefault();
    let errorArr = [];
    if (
      typeof businessAddressDetails.checksDetails !== "undefined" &&
      businessAddressDetails.checksDetails !== null
    ) {
      const checksDetails = businessAddressDetails.checksDetails;
      for (var i in checksDetails) {
        let x = index - 1;
        let obj = [];
        if (i == x) {
          for (var j in checksDetails[index - 1].fields) {
            let isFieldMandatory =
              checksDetails[index - 1].fields[j].is_mandatory;
            if (j == "till_date") {
              isFieldMandatory =
                checksDetails[index - 1].fields["residing_from"] &&
                checksDetails[index - 1].fields["residing_from"].field_value !=
                  ""
                  ? 0
                  : 1;
              checksDetails[index - 1].fields[j].is_mandatory =
                isFieldMandatory;
            }

            if (j == "residing_from") {
              const isTillDateChecked =
                tillDateChecked[index - 1] && tillDateChecked[index - 1] == true
                  ? true
                  : false;
              if (isTillDateChecked) {
                checksDetails[index - 1].fields[j].is_mandatory = 0;
              }
            }

            if (
              checksDetails[index - 1].fields[j].is_mandatory == 1 &&
              (checksDetails[index - 1].fields[j].field_value.trim() == "" ||
                checksDetails[index - 1].fields[j].field_value == null)
            ) {
              obj[j] = true;
            } else {
              if (j === "pin_code"&&checksDetails[index - 1].fields["address_belongs_to"].field_value=='Within India') {
                let valid = validatePincode(
                  checksDetails[index - 1].fields[j].field_value
                );
                obj[j] = !valid;
              } else {
                obj[j] = false;
              }
            }
          }
        }
        errorArr.push(obj);
      }
    }
    setErrorData(errorArr);
    let isThereAnyError = false;
    for (var i in errorArr[index - 1]) {
      if (errorArr[index - 1][i] == true) {
        isThereAnyError = true;
        break;
      }
    }
    if (isThereAnyError) {
      props.setIsLoading(false);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      return;
    } else {
      saveAddressDetails(index - 1, caseCheckId);
    }
  };

  const saveAddressDetails = (checksDetailsIndex, caseCheckId) => {
    let savedDetailsObj = {};
    const fieldDetails = _.cloneDeep(
      businessAddressDetails.checksDetails[checksDetailsIndex].fields
    );
    savedDetailsObj["group"] = "business_address";
    for (var i in fieldDetails) {
      if (
        fieldDetails[i].field_value !== "" &&
        fieldDetails[i].field_value !== null
      ) {
        savedDetailsObj[`${fieldDetails[i].id}`] = fieldDetails[i].field_value;
      }

      if (fieldDetails[i].label === "Residing To") {
        if (
          tillDateChecked[checksDetailsIndex] &&
          tillDateChecked[checksDetailsIndex] === true
        ) {
          savedDetailsObj[`${fieldDetails[i].id}`] = "";
        }
      }
    }
    props.setIsLoading(false);
    let finalData = {};
    finalData[`${caseCheckId}`] = savedDetailsObj;
    const checksLength = Object.keys(
      businessAddressDetails.checksDetails
    ).length;
    if (
      businessAddressDetails.is_address_validation == 1 &&
      activeTab == checksLength &&
      isValidated != 1
    ) {
      dispatch(businessAddressValidation(caseCheckId, finalData, activeTab));
    } else {
      dispatch(saveBusinessAddress(caseCheckId, finalData, activeTab));
    }
  };

  useEffect(() => {
    if (
      typeof businessAddressDetails.checksDetails !== "undefined" &&
      businessAddressDetails.checksDetails !== null
    ) {
      const checksDetails = businessAddressDetails.checksDetails;
      let isIndiaArr = [];
      let tillDateCheckedObj = {};
      setDateConditions(checksDetails);
      if (checksDetails) {
        for (var i in checksDetails) {
          for (var j in checksDetails[i].fields) {
            if (j === "address_belongs_to") {
              const isIndia =
                checksDetails[i].fields[j].field_value === "Within India"
                  ? true
                  : false;
              isIndiaArr.push(isIndia);
            }

            if (j === "till_date") {
              tillDateCheckedObj[parseInt(i)] =
                checksDetails[i].fields[j].field_value === "1" ? true : false;
            }
          }
        }
      }
      setIsIndia(isIndiaArr);
      setTillDateChecked(tillDateCheckedObj);
    }
  }, [businessAddressDetails, businessAddress]);

  const setDateConditions = (checksDetails) => {
    let minDol = {};
    let maxDoj = {};
    for (var i in checksDetails) {
      //if (checksDetails[i].check_id == "41") {
      const startDate = checksDetails[i].fields["residing_since"]
        ? checksDetails[i].fields["residing_since"].field_value
        : "";
      const endDate = checksDetails[i].fields["residing_from"]
        ? checksDetails[i].fields["residing_from"].field_value
        : "";
      if (startDate !== "") {
        const [dd, mm, yyyy] = startDate.split("-");
        const futureDate = new Date(`${mm}/${dd}/${yyyy}`);
        futureDate.setDate(futureDate.getDate() + 1);
        minDol[`${i}`] = futureDate;
      } else {
        minDol[`${i}`] = null;
      }

      if (endDate !== "") {
        const [dd, mm, yyyy] = endDate.split("-");
        const pastDate = new Date(`${mm}/${dd}/${yyyy}`);
        pastDate.setDate(pastDate.getDate() - 1);
        maxDoj[`${i}`] = pastDate;
      } else {
        maxDoj[`${i}`] = null;
      }
      //}
    }
    setMaxDOJ(maxDoj);
    setMinDOL(minDol);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };
  return (
    <>
      {loading && <Loader />}
      {showValidationPopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeValidationPopup}
          title={validationPopupTitle}
          description={validationPopupMsg}
          proceedHandler={proceedValidation}
          isAdd={false}
        />
      )}
      <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {activeTab &&
            Object.keys(businessAddressDetails).length > 0 &&
            Object.entries(businessAddressDetails.checksDetails).map(
              ([key, value]) => {
                const index = parseInt(key) + 1;
                const caseCheckId = value.case_check_id;
                const caseCheckStatus = value.check_status;
                let activeClass = "";
                if (typeof active !== "undefined") {
                  if (active == caseCheckId) {
                    activeClass = "active";
                  }
                } else if (index === 1) {
                  activeClass = "active";
                }
                let completeClass = "";
                if (caseCheckStatus === 2) {
                  completeClass = "completed";
                }
                let check_name = value.IB_CHECK_NAME;
                return (
                  <li className="nav-item" key={key}>
                    <a
                      className={`tab nav-link ${activeClass} ${completeClass}`}
                      id={`businessAddress-tab-${index}`}
                      data-toggle="tab"
                      href={`#businessAddress-${index}`}
                      role="tab"
                      aria-controls={`businessAddress-${index}`}
                      aria-selected="true"
                      data-index={index - 1}
                      data-casecheckid={caseCheckId}
                      onClick={(e) => changeActiveTab(index, caseCheckId)}
                    >
                      {caseCheckStatus === 2 && (
                        <i class="fas fa-check-circle mr-1"></i>
                      )}
                      {check_name}
                    </a>
                  </li>
                );
              }
            )}
        </ul>
      </div>
      <hr />
      <div className="tab-content" id="myTabContent">
        {errorData.length > 0 &&
          businessAddressDetails.checksDetails &&
          Object.keys(businessAddressDetails.checksDetails).length ===
            errorData.length &&
          Object.entries(businessAddressDetails.checksDetails).map(
            ([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              let activeClass = "";
              if (typeof active !== "undefined") {
                if (active == caseCheckId) {
                  activeClass = "show active";
                }
              } else if (index === 1) {
                activeClass = "show active";
              }

              return (
                <div
                  className={`tab-pane fade ${activeClass}`}
                  id={`businessAddress-${index}`}
                  role="tabpanel"
                  aria-labelledby={`businessAddress-tab-${index}`}
                  key={key}
                >
                  <div className="row" style={{ marginBottom: "15px" }}>
                    {value.fields.address_belongs_to ? (
                      <ADDRadio
                        name={`address_belongs_to_${caseCheckId}`}
                        id={`address_belongs_to_${caseCheckId}`}
                        fieldId={
                          value.fields.address_belongs_to.ibridge_field_id
                        }
                        label={value.fields.address_belongs_to.label}
                        isRequired={
                          value.fields.address_belongs_to.is_mandatory
                        }
                        errId={`err_${caseCheckId}_${value.fields.address_belongs_to.ibridge_field_id}`}
                        options={
                          value.fields.address_belongs_to.getFieldDisplay
                            .optionArray.options
                        }
                        handleRadioChange={handleRadioChange}
                        checkDetailsIndex={key}
                        fieldName={"address_belongs_to"}
                        fieldValue={value.fields.address_belongs_to.field_value}
                        hasError={errorData[index - 1]["address_belongs_to"]}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="row">
                    {value.fields.company_name ? (
                      <ADDAutoCompleteSelect
                        name={`company_name_${caseCheckId}`}
                        id={`company_name_${caseCheckId}`}
                        fieldId={value.fields.company_name.ibridge_field_id}
                        label={value.fields.company_name.label}
                        isRequired={value.fields.company_name.is_mandatory}
                        errId={`err_${caseCheckId}_${value.fields.company_name.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={key}
                        fieldName={"company_name"}
                        fieldValue={value.fields.company_name.field_value}
                        hasError={errorData[index - 1]["company_name"]}
                        verificationType={2}
                      />
                    ) : (
                      <></>
                    )}
                    {value.fields.industry_type ? (
                      <ADDSelect
                        name={`industry_type_${caseCheckId}`}
                        id={`industry_type_${caseCheckId}`}
                        label={value.fields.industry_type.label}
                        autoComplete="off"
                        options={industries}
                        isRequired={value.fields.industry_type.is_mandatory}
                        caseCheckId={caseCheckId}
                        handleSelectChange={handleSelectChange}
                        checkDetailsIndex={key}
                        fieldName={"industry_type"}
                        fieldValue={value.fields.industry_type.field_value}
                        hasError={errorData[index - 1]["industry_type"]}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="row">
                    {value.fields.address ? (
                      <ADDText
                        name={`address_${caseCheckId}`}
                        id={`address_${caseCheckId}`}
                        fieldId={value.fields.address.ibridge_field_id}
                        label={value.fields.address.label}
                        isRequired={value.fields.address.is_mandatory}
                        errId={`err_${caseCheckId}_${value.fields.address.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={key}
                        fieldName={"address"}
                        fieldValue={value.fields.address.field_value}
                        hasError={errorData[index - 1]["address"]}
                      />
                    ) : (
                      <></>
                    )}
                    {value.fields.colony_street ? (
                      <ADDText
                        name={`colony_street_${caseCheckId}`}
                        id={`colony_street_${caseCheckId}`}
                        fieldId={value.fields.colony_street.ibridge_field_id}
                        label={value.fields.colony_street.label}
                        isRequired={value.fields.colony_street.is_mandatory}
                        errId={`err_${caseCheckId}_${value.fields.colony_street.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={key}
                        fieldName={"colony_street"}
                        fieldValue={value.fields.colony_street.field_value}
                        hasError={errorData[index - 1]["colony_street"]}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="row">
                    {value.fields.landmark_additional_address ? (
                      <ADDText
                        name={`landmark_additional_address_${caseCheckId}`}
                        id={`landmark_additional_address_${caseCheckId}`}
                        fieldId={
                          value.fields.landmark_additional_address
                            .ibridge_field_id
                        }
                        label={value.fields.landmark_additional_address.label}
                        isRequired={
                          value.fields.landmark_additional_address.is_mandatory
                        }
                        errId={`err_${caseCheckId}_${value.fields.landmark_additional_address.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={key}
                        fieldName={"landmark_additional_address"}
                        fieldValue={
                          value.fields.landmark_additional_address.field_value
                        }
                        hasError={
                          errorData[index - 1]["landmark_additional_address"]
                        }
                      />
                    ) : (
                      <></>
                    )}
                    {value.fields.police_station ? (
                      <ADDText
                        name={`police_station_${caseCheckId}`}
                        id={`police_station_${caseCheckId}`}
                        fieldId={value.fields.police_station.ibridge_field_id}
                        label={value.fields.police_station.label}
                        isRequired={value.fields.police_station.is_mandatory}
                        errId={`err_${caseCheckId}_${value.fields.police_station.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={key}
                        fieldName={"police_station"}
                        fieldValue={value.fields.police_station.field_value}
                        hasError={errorData[index - 1]["police_station"]}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="row">
                    {value.fields.pin_code ? (
                      <ADDText
                        name={`pin_code_${caseCheckId}`}
                        id={`pin_code_${caseCheckId}`}
                        fieldId={value.fields.pin_code.ibridge_field_id}
                        label={value.fields.pin_code.label}
                        isRequired={value.fields.pin_code.is_mandatory}
                        errId={`err_${caseCheckId}_${value.fields.pin_code.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={key}
                        fieldName={"pin_code"}
                        fieldValue={value.fields.pin_code.field_value}
                        hasError={
                          errorData[index - 1]["pin_code"]  ||
                          (value.fields.address_belongs_to.field_value=='Within India'&&value.fields.pin_code.field_value
                            ? !validatePincode(
                                value.fields.pin_code.field_value
                              )
                            : false)
                        }
                      />
                    ) : (
                      <></>
                    )}
                    {value.fields.city ? (
                      <ADDText
                        name={`city_${caseCheckId}`}
                        id={`city_${caseCheckId}`}
                        fieldId={value.fields.city.ibridge_field_id}
                        label={value.fields.city.label}
                        isRequired={value.fields.city.is_mandatory}
                        errId={`err_${caseCheckId}_${value.fields.city.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={key}
                        fieldName={"city"}
                        fieldValue={value.fields.city.field_value}
                        hasError={errorData[index - 1]["city"]}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="row">
                    {value.fields.location ? (
                      <ADDText
                        name={`location_${caseCheckId}`}
                        id={`location_${caseCheckId}`}
                        fieldId={value.fields.location.ibridge_field_id}
                        label={value.fields.location.label}
                        isRequired={value.fields.location.is_mandatory}
                        errId={`err_${caseCheckId}_${value.fields.location.ibridge_field_id}`}
                        handleTextChange={handleTextChange}
                        checkDetailsIndex={key}
                        fieldName={"location"}
                        fieldValue={value.fields.location.field_value}
                        hasError={errorData[index - 1]["location"]}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="row">
                    {value.fields.residing_since ? (
                      <ADDDate
                        paramStartDate={null}
                        placeholder={value.fields.residing_since.label}
                        name={`residing_since_${caseCheckId}`}
                        id={`residing_since_${caseCheckId}`}
                        fieldId={value.fields.residing_since.ibridge_field_id}
                        label={value.fields.residing_since.label}
                        isRequired={value.fields.residing_since.is_mandatory}
                        errId={`err_${caseCheckId}_${value.fields.residing_since.ibridge_field_id}`}
                        intialStatus={0}
                        saveDate={handleSaveDate}
                        checkDetailsIndex={key}
                        maxDOJDate={maxDOJ[key]}
                        fieldName={"residing_since"}
                        fieldValue={value.fields.residing_since.field_value}
                        hasError={errorData[index - 1]["residing_since"]}
                      />
                    ) : (
                      <></>
                    )}
                    {value.fields.residing_from &&
                    !(
                      tillDateChecked[index - 1] &&
                      tillDateChecked[index - 1] === true
                    ) ? (
                      <ADDDate
                        paramStartDate={null}
                        placeholder={value.fields.residing_from.label}
                        name={`residing_from_${caseCheckId}`}
                        id={`residing_from_${caseCheckId}`}
                        fieldId={value.fields.residing_from.ibridge_field_id}
                        label={value.fields.residing_from.label}
                        // isRequired={
                        //   value.fields.residing_from.is_mandatory
                        // }
                        isDisabled={
                          tillDateChecked[index - 1] &&
                          tillDateChecked[index - 1] === true
                            ? true
                            : false
                        }
                        errId={`err_${caseCheckId}_${value.fields.residing_from.ibridge_field_id}`}
                        intialStatus={0}
                        saveDate={handleSaveDate}
                        checkDetailsIndex={key}
                        minDateDOL={minDOL[key]}
                        fieldName={"residing_from"}
                        fieldValue={value.fields.residing_from.field_value}
                        hasError={errorData[index - 1]["residing_from"]}
                      />
                    ) : (
                      <></>
                    )}
                    {value.fields.till_date ? (
                      <ADDCheckbox
                        name={`till_date_${caseCheckId}`}
                        id={`till_date_${caseCheckId}`}
                        fieldId={value.fields.till_date.ibridge_field_id}
                        label={value.fields.till_date.label}
                        isRequired={value.fields.till_date.is_mandatory}
                        errId={`err_${caseCheckId}_${value.fields.till_date.ibridge_field_id}`}
                        handleCheckboxChange={handleCheckboxChange}
                        checkDetailsIndex={key}
                        fieldName={"till_date"}
                        fieldValue={value.fields.till_date.field_value}
                        hasError={errorData[index - 1]["till_date"]}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="row mt-3">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        id={"saveHandlerElement"}
                        onClick={(e) => saveHandler(e, caseCheckId, index)}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  {Object.keys(businessAddressDetails).length > 0 &&
                    businessAddressDetails.showProfilePreview == 1 && (
                      <div className="row">
                        <div className="col-auto d-flex justify-content-between">
                          <button
                            className="btn btn-primary btn-lg btn-block mt-3"
                            onClick={(e) => handleSubmitForPreview(e)}
                          >
                            {clientId == 459831 ? "Preview" : "Submit for Preview"}
                          </button>
                        </div>
                        <div className="col-auto d-flex justify-content-between mt-4">
                          <small className="text-muted">
                            Please complete all the mandatory fields before
                            final submission
                          </small>
                        </div>
                      </div>
                    )}
                </div>
              );
            }
          )}
      </div>
    </>
  );
};

export default MainForm;
